<template>
  <div class="modal-overlay">
    <div class="modal-content" style="max-width: 70vw">
      <!-- HEADER -->
      <div class="modal-header">
        <h5 class="modal-title">Complications / Events Log</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>

      <!-- LOADER -->
      <div v-if="loading" class="modal-body">
        <loader />
      </div>

      <!-- BODY -->
      <div  v-else class="modal-body">
        <!-- Minutes -->
        <div class="form-group">
          <label>Time Lapsed (min):</label>
          <input v-model="form.minutes_lapsed" type="number" min="0" readonly />
        </div>

        <!-- Observed Complications -->
        <h4>Observed Complications</h4>
        <div class="checkbox-grid">
          <div>
            <input
              type="checkbox"
              id="hypotension"
              value="hypotension"
              v-model="form.observed_complications"
            />
            <label for="hypotension">Hypotension</label>
          </div>

          <div>
            <input
              type="checkbox"
              id="cramps"
              value="cramps"
              v-model="form.observed_complications"
            />
            <label for="cramps">Cramps</label>
          </div>

          <div>
            <input
              type="checkbox"
              id="nausea"
              value="nausea_vomiting"
              v-model="form.observed_complications"
            />
            <label for="nausea">Nausea / Vomiting</label>
          </div>

          <div>
            <input
              type="checkbox"
              id="clotting"
              value="clotting"
              v-model="form.observed_complications"
            />
            <label for="clotting">Clotting of Circuit</label>
          </div>

          <div>
            <input
              type="checkbox"
              id="bleeding"
              value="bleeding"
              v-model="form.observed_complications"
            />
            <label for="bleeding">Bleeding at Access Site</label>
          </div>
        </div>

        <!-- Notes -->
        <div class="form-group">
          <label>Patient Complaints / Notes:</label>
          <textarea v-model="form.patient_complaints" rows="3"></textarea>
        </div>
      </div>

      <!-- FOOTER -->
      <div v-if="!loading" class="modal-footer">
        <button class="btn-secondary" @click="closeModal">Cancel</button>
        <button class="btn-primary" @click="saveComplications">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
import loader from "./loader.vue";
import getElapsedMinutes from "./lapsed_minutes";
import { generalApiRequest } from "../../../api/apiIndex";

export default {
  name: "ComplicationsModal",

  props: {
    session_id: {
      type: [Number, String],
      required: true,
    },
  },

  components: {
    loader,
  },

  data() {
    return {
      loading: false,
      form: {
        session_id: null,
        minutes_lapsed: "",
        observed_complications: [], // ✅ SINGLE ARRAY
        patient_complaints: "",
      },
    };
  },

  methods: {
    closeModal() {
      this.$emit("close-complications-modal");
    },

    async loadElapsedMinutes() {
      this.loading = true;
      try {
        const minutes = await getElapsedMinutes(this.session_id);
        this.form.minutes_lapsed = minutes;
      } finally {
        this.loading = false;
      }
    },

    async saveComplications() {
      this.loading = true;
      console.log(this.form);

      try {
        this.form.session_id = this.session_id;

        const response = await generalApiRequest(
          "dialysis-complications",
          "POST",
          this.form,
          1
        );

        console.log(response);
        this.closeModal();
      } finally {
        this.loading = false;
      }
    },
  },

  mounted() {
    this.loadElapsedMinutes();
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(31, 31, 31, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: white;
  padding: 1.5rem;
  border-radius: 0.5rem;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.modal-title {
  font-size: 1.2rem;
  font-weight: 600;
}

.close {
  background: #e31919;
  border: none;
  color: white;
  font-size: 1.4rem;
  padding: 0.3rem 0.6rem;
  cursor: pointer;
  border-radius: 0.3rem;
}

.form-group {
  margin-bottom: 0.9rem;
}

.form-group label {
  font-weight: 600;
  display: block;
  margin-bottom: 0.2rem;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 0.45rem;
  border: 1px solid #ccc;
  border-radius: 0.3rem;
}

.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.5rem 1rem;
  margin-bottom: 1rem;
}

.checkbox-grid input {
  margin-right: 0.4rem;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.7rem;
  padding-top: 1rem;
  border-top: 1px solid #ddd;
}

.btn-primary {
  background: #2786f7;
  color: white;
  padding: 0.45rem 0.9rem;
  border: none;
  border-radius: 0.3rem;
  cursor: pointer;
}

.btn-secondary {
  background: #bbb;
  color: white;
  padding: 0.45rem 0.9rem;
  border: none;
  border-radius: 0.3rem;
  cursor: pointer;
}

h4 {
  margin: 0.8rem 0 0.5rem;
  font-size: 1.05rem;
  color: #333;
}
</style>
